import { DomainMessagesTypes } from 'shared/domain/messages/message';
import { workflowContract } from 'shared/domain/workflow/workflowContract';
import { makeErrorPublisher } from 'serviceWorker/broadcasts/publishers';

const broadcastError = makeErrorPublisher(
  workflowContract
);

export function broadcastWorkflowError(
  error: unknown,
  uniqueId?: string,
  messageId?: string | null
): void {
  broadcastError(DomainMessagesTypes.workflowError, error, {
    uniqueId,
    messageId: messageId ?? null,
  });
}

export function broadcastStageError(
  error: unknown,
  uniqueId?: string,
  messageId?: string | null
): void {
  broadcastError(DomainMessagesTypes.stageError, error, {
    uniqueId,
    messageId: messageId ?? null,
  });
}

export function broadcastDecisionError(
  error: unknown,
  uniqueId?: string,
  messageId?: string | null
): void {
  broadcastError(DomainMessagesTypes.decisionError, error, {
    uniqueId,
    messageId: messageId ?? null,
  });
}
